import { RadarWidgetLazy } from './radarWidgetLazy';

const props = [];

export const MapWidgetDirective = reactDirective => reactDirective(RadarWidgetLazy, props);
MapWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('mapWidget', MapWidgetDirective);
